import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class BarcodeType extends BaseDataModel {
	name: string = "";
}
